<template>
  <div>
    <div class="container-fluid">
      <div class="mb-3" :class="{'section-loading': infoLoading}" style="overflow: hidden;max-height: 148px;">
        <div class="float-left w-75  pr-3" >
          <h4 class="mb-line text-green mt-0 mb-0">{{ categoryInfo.subcategory }}-{{ categoryInfo.category_name }}  
            <!--<i v-if="categoryInfo.upload_file =''" class="icon-attach text-orange ml-2"></i>
            <span style="font-size: medium;color: black;">{{ categoryInfo.upload_file | removeExten }}</span>-->
            <a class="text-orange" style="text-decoration:none;">
              <i style="cursor:pointer;" class="icon-attach ml-2" @click="download()"></i>
            </a>
          </h4>
          <div class="mb-line" style=""><span class="font-weight-bold mr-2">{{ categoryInfo.upload_date | dateFormat }} ~ {{ categoryInfo.end_date | dateFormat }}</span></div>
          <div class="mb-line"><span class="font-weight-bold mr-2">{{ categoryInfo.description }}</span></div>
        </div>
        <div class="float-left w-25">
          <div class="mb-line"><span class="font-weight-bold mr-2">維護單位</span> <span>{{ categoryInfo.dev_name }}</span></div>
          <div class=""><span class="font-weight-bold mr-2">聯絡電話</span> <span>{{ categoryInfo.contact }}</span></div>
          <div class="mb-line"><span class="font-weight-bold mr-2">聯絡分機</span> <span>{{ categoryInfo.contact_tel }}</span></div>
          <div class="mb-line"  :class="{'section-loading': isLoading_btn}">
            <a class="btn btn-default m-0" @click="satisfactionModal" v-if="isBtnEnble">滿意度調查</a>
            <a class="btn btn-default m-0" @click="alreadyDone" disabled="disabled" v-else>滿意度調查</a>
            &nbsp;&nbsp;
            <button
            type="button"
            style="height:43px;"
            @click="backToIndex"
            class="position-absolute btn btn-default m-0"
            v-html="'<span style=\'font-size:1rem\'>回上一頁<span>'"
          ></button> 
          </div>
           <div class="mb-line"><span class="font-weight-bold mr-2 text text-red">上限:{{ selection.length }}位要保人/100位要保人</span></div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="container-fluid" :class="{'section-loading': subsLoading}">
      <div class="row">
        <section class="newTable">
          <table class="table datatable table-striped area-list-datatable">
            <thead>
              <tr>
                <th :width="screenWidth * 0.10">
                  <div class="checkbox checkbox-inline mr-0">
                    <input
                    type="checkbox"
                    :name="`substantial-check-all`" 
                    :id="`substantial-check-all`"
                    v-model="checkAll"
                    @click="clickTarget = clickTarget == `clickAll`? `clickAll-again`: `clickAll`">
                    <label :for="`substantial-check-all`"></label>
                  </div>
                  <span>#</span>
                </th>
                <th :width="screenWidth * 0.1" class="sorting" 
                :class="'sorting ' + (order.fieldName == 'ceapcnm' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                @click="columnSorting('ceapcnm')">姓名<br>(要保人資料）</th>
                <th :width="screenWidth * 0.086">專函<br>(含明細）</th>
                <th :width="screenWidth * 0.096" class="sorting" 
                :class="'sorting ' + (order.fieldName == 'ceplcno' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                @click="columnSorting('ceplcno')">保單號碼<br>(契約效力)</th>
                <th :width="screenWidth * 0.10" class="sorting" 
                :class="'sorting ' + (order.fieldName == 'idmark' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                @click="columnSorting('idmark')">客戶標記</th>
                <th :width="screenWidth * 0.086" class="sorting" 
                :class="'sorting ' + (order.fieldName == 'cenxpdt' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                @click="columnSorting('cenxpdt')">下次應繳日</th>
                <th :width="screenWidth * 0.096" class="sorting" 
                :class="'sorting ' + (order.fieldName == 'printday' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                @click="columnSorting('printday')">專函列印日<br>(保戶通聯）</th>
                <th :width="screenWidth * 0.096" class="sorting" 
                :class="'sorting ' + (order.fieldName == 'last_visitday' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                @click="columnSorting('last_visitday')">實質接觸期限</th>
                <th :width="screenWidth * 0.086">是否失聯</th>
                <th width="*">排訪</th>
              </tr>
            </thead>
            <tbody :style="{ height: scrollHeight + 'px' }">
              <tr v-for="(item, index) in tableDataBackup" :key="`out-${index}`">
                <td :width="screenWidth * 0.10">
                  <div style="min-height: 30px;">
                    <div class="mr-0 checkbox checkbox-inline">
                      <input
                      @click="clickTarget = clickTarget == `td-${index}`? `td-${index}-again`: `td-${index}`"
                      type="checkbox"
                      name="`td-item[]`"
                      :id="`check-out-${index}`"
                      :value="item.ceapcno"
                      v-model="selection"
                      :disabled="item.ceapcno === ''"
                      @change="$emit('update', selection)">
                      <label :for="`check-out-${index}`"></label>
                    </div>
                    <span>
                      <span class="no">{{index + 1}}</span>
                      <span class="info text-center">
                          <level :lv="Number(item.vip_level)" />
                          <avatar :gender="Number(item.ceapcno.charAt(1))" :size="20" />
                      </span>
                    </span>
                  </div>
                </td>
                <td :width="screenWidth * 0.1">
                  <Tooltip :position="index < 3?'bottom':'top'" :name="item.ceapcnm">
                   <template v-if="item.is_exist">
                    <a
                      class="link text-underline"
                      @click="toCustDetail({custId: item.ceapcno, custName: item.name})"
                      >{{item.ceapcnm | getMaskName}}</a>
                    </template>
                    <template v-else>{{item.ceapcnm | getMaskName}}</template>
                  </Tooltip>
                </td>
                <td :width="screenWidth * 0.086">
                  <span>
                    <a @click="openSendModal(item, '1')" class="link line-height-2 text-underline">親送專函</a><br />
                    <a @click="openSendModal(item, '2')" class="link line-height-2 text-underline">郵寄專函</a>  
                  </span>
                </td>
                <td :width="screenWidth * 0.096">{{ item.ceplcno }}<br>{{ item.celpscs_nm }}</td>
                <td :width="screenWidth * 0.10">{{ item.idmark | IDmarkFormat }}</td>
                <td :width="screenWidth * 0.086">{{ item.cenxpdt | dateFormat }}</td>
                <td :width="screenWidth * 0.096">
                  <span>{{item.printday| dateFormat }}</span>
                  <br>
                  <a @click.prevent="openAddressModal(item.ceapcno, item.ceapcnm)" class="link text-underline">查詢</a>
                </td>
                <td :width="screenWidth * 0.096">{{ item.last_visitday | dateFormat }}</td>
                <td :width="screenWidth * 0.086" class="text-center">
                  <a @click.prevent="openMissingModal(item.visit_no, item.ceapcno)" class="link text-underline">{{item.contact !="" ? item.contact :'輸入'}}</a>
                </td>
                <td v-if="isBox">
                  <button 
                  v-if="!item.visit.csidno"
                  class="btn btn-primary" 
                  @click="callBoxVisit(item)"
                  v-html="'<span style=\'font-size:1.25rem\'>預約<span>'"></button>
                  <button 
                  v-else
                  class="btn btn-primary" style="font-size:0.8rem;" 
                  @click="callBoxVisit(item)">{{ item.visit.str_date | dateFormat }}<br>{{ item.visit.str_time }}</button>
                </td>
                <td v-else>
                  <button 
                  v-if="!item.visit.csidno"
                  class="btn btn-primary" 
                  @click="ScheduledAccess(item)"
                  v-html="'<span style=\'font-size:1.25rem\'>預約<span>'"></button>
                  <button 
                  v-else
                  class="btn btn-primary" style="font-size:0.8rem;" 
                  @click="ScheduledAccess(item)">{{ item.visit.str_date | dateFormat }}<br>{{ item.visit.str_time }}</button>
                </td>
              </tr>
              <tr v-if="tableDataBackup.length == 0">
                <td colspan="8" class="text-center pt-3 pb-5">
                  <h3>
                    無客戶名單資料
                  </h3>
                </td>
                <td style="display: none;"></td>
                <td style="display: none;"></td>
                <td style="display: none;"></td>
                <td style="display: none;"></td>
                <td style="display: none;"></td>
                <td style="display: none;"></td>
                <td style="display: none;"></td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    </div>

    <section class="container-fluid fixed-bottom">
      <div class="row align-item-center align-content-center">
        <div class="col-12"></div>
        <div class="col-6 col-sm-6 col-md-6">
        </div>
        <div class="col-6 col-sm-6 col-md-6 text-right">
           <button class="btn btn-primary"
          @click="panelOpen('groupModalOpen')"
          :disabled="!selection.length">
            加入群組
          </button>
          <button class="btn btn-primary mr-0"
          @click="panelOpen('printModalOpen')"
          :disabled="!selection.length">
            列印名條
          </button>
          <button class="btn btn-primary mr-0"
          @click= openPrintAllModal()
          :disabled="!selection.length">
            列印專函
          </button>
        </div>
      </div>
    </section>

    <!-- 專函 -->
    <send-modal 
      :open="sendModalOpen"
      :cust-data="sendCustData"
      :sendtype="sendType"  
      @close="ClosesendModal()"/>

    <!-- 列印專函(一次多筆)-->
    <print-all-modal
    :open="printallModalOpen"
    :custs="selection"
    @close="Closeprintall()"
    />

    <!-- 保戶通聯查詢 -->
    <integrated-address-modal
      :open="IntegratedAddressModalOpen"
      :address-data='addressData'
      @close="panelClose('IntegratedAddressModalOpen')"
    />

    <!-- 失聯回報 -->
    <missing-modal :open="MissingModalOpen"
    :contact="missingContact"
    @submit="updateMissing"
    @close="panelClose('MissingModalOpen')" />

    <!-- 列印名條 -->
    <print-modal
    :open="printModalOpen"
    :custs="selection"
    @close="panelClose('printModalOpen')"/>

    <!-- 加入群組 -->
    <group-modal
    :open="groupModalOpen"
    :custs="selection"
    @submit="submitGroup"
    @close="panelClose('groupModalOpen')"/>

    <satisfaction-modal 
    :open="satisfactionModalOpen"
    @report="report"
    @close="panelClose('satisfactionModalOpen')"/>

    <!-- 排訪 -->
	  <scheduled-access
    :open="ScheduledAccessModalOpen"
    :record="currentRecord"
    :cat-info="categoryInfo"
    @close="panelClose('ScheduledAccessModalOpen')"
    @submit="submitScheduledAccess"
    />

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import SendModal from "../SendModal";
import PrintAllModal from "../PrintAllModal";
import IntegratedAddressModal from "../IntegratedAddressModal";
import MissingModal from "../MissingModal"
import PrintModal from '@/desktop/components/PrintModal'
import GroupModal from '@/desktop/components/GroupModal'
import Level from '@/components/Level'
import Avatar from '@/components/Avatar'
import SatisfactionModal from '../SatisfactionModal'
import { getChangeNotice, getChangePrint, getChangeReprot, 
getChangeUpdateReprot, queryBelowEstrangePolicyContactInfo, getCategoryDetail,
isSatisfactionSurveyFinish, queryBookedVisitEvent } from '@/service'
import $ from 'jquery';
import { downloadFile_m0 } from '@/service'
import { saveAs } from 'file-saver';
import ScheduledAccess from '../ScheduledAccess'
import Tooltip from '@/desktop/components/ToolTip'

export default {
  name: "SubstantialContactDetails",
  mixins: [commonMixin],
  components: {
    SendModal,
    PrintAllModal,
    IntegratedAddressModal,
    MissingModal,
    Level,
    Avatar,
    PrintModal,
    GroupModal,
    SatisfactionModal,
    ScheduledAccess,
    Tooltip
  },
  computed : {
    ...mapGetters([ 'UserInfo' ]),
    isBox() {
     //判斷是否為box
     return this.UserInfo.userType === 'box'
    }
  },
  watch: {
      clickTarget: function(target){
        if(target == 'clickAll' || target == 'clickAll-again') {  //點了全選checkbox
          if(this.checkAll) {  //點了全選
            this.selection = []
            this.distinctid.forEach(data => {
              this.selection.push(data)
            });
          } else {  //取消全選
            this.selection = []
          }
        } else {  //點了其他checkbox
          this.checkAll = this.selection.length == this.distinctid.length
        }
        this.$emit('update', this.selection)
      },    
  },
  props: {
    status: String
  },
  filters: {
    
  },
  data() {
    //data block layout
    return {
      subsLoading: false,
      infoLoading: false,
      printModalOpen: false,
      groupModalOpen: false,
      isBtnEnble: true,
      isLoading_btn: false,
      sendType: 'send',
      categoryInfo: {},
      currentPage: 0,
      totalpages: 0,
      tableData: [],
      tableDataBackup: [],
      visitList: [],
      allIdData:[],
      distinctid:[],
      clickTarget:'',
      checkAllClick: false,
      checkAll: false,
      addPageStatus: false,
      remoteDataMsg: "資料讀取中，請稍候...",
      selection: [],
      sendModalOpen: false,
      printallModalOpen: false,
      IntegratedAddressModalOpen: false,
      message: "",
      MissingModalOpen: false,
      title: "",
      screenWidth: document.body.clientWidth > 1208 ? 1280 : document.body.clientWidth,
      scrollHeight: 0,
      order: {
          fieldName: 'ceapcnm',
          asc: true
      },      
      addressData: {},
      missingContact: '',
      missVisit: '',
      missCustId: '',
      sendCustData: {},
      satisfactionModalOpen: false,
      currentRecord: {},
      ScheduledAccessModalOpen: false,
    };
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustInfo", "updateCustID", "updateSerNo"]),
    initCustList () {  // 初始化
      this.subsLoading = true;
      this.checkAll = false;
      this.selection = [];
      getChangeNotice(this.$store.state.userInfo.id,0).then(result => {  // 取得客戶列表
        this.subsLoading = false;
        if(result && result.header.status == '200' && result.body){
          let lists = result.body.notice_list || [];
          let connect = '';
          let CsidData = '';
          lists.map(item => {
              connect = connect+','+item.ceapcno;
          })
          if(connect.length > 0){
            CsidData = connect.substr(1);
          } else {
            CsidData = '';
          }
          this.order.fieldName = 'name';
          this.order.asc = true;
          queryBookedVisitEvent(this.$store.state.userInfo.id,CsidData).then(visitData => {
            this.subsLoading = false;
            if(visitData.header && visitData.header.status === '200') {
              this.visitList = visitData.body.detail;
              this.tableData = lists.map(item => {
                let visit = {visit: {}};
                this.visitList.forEach(vItem => {
                  if(vItem.csidno == item.ceapcno) {
                    visit.visit = vItem;
                  }
                })
                return {
                  ceapcnm: item.ceapcnm || '', //姓名(要保人資料）
                  name: item.ceapcnm || '', //客戶姓名
                  id:item.ceapcno || '', //客戶id
                  ceapcno: item.ceapcno || '', //客戶ID
                  celpscs_nm: item.celpscs_nm || '', //契約效力
                  ceplcno: item.ceplcno || '', //保單號碼
                  clcid : item.clcid || '',
                  contact : item.contact || '', //失聯狀況
                  fin : item.fin ||'',
                  idmark : item.idmark || '', //客戶標記
                  last_visitday: item.last_visitday || '',//實質接觸期限
                  cenxpdt: item.cenxpdt || '', //下次應繳日
                  visit_no: item.visit_no || '',//拜訪編號，存失聯件用
                  is_exist: item.is_exist || false, //判斷是否有客戶資料
                  printday: item.print_day || '', //列印日期
                  ...visit // 寫入排訪資料
                }
              })
              this.allIdData = this.tableData.map(ele => {return ele.ceapcno;});
              this.distinctid = this.allIdData.filter(function(element, index, arr){
                  return arr.indexOf(element) === index;
              });
              this.tableDataBackup = this.tableData.map(ele => {return ele;});
            }
          })
          this.registerHanlink();  // for hard word
        }
      })

      // 取得專區資訊
      this.getTitleInfo()

      // 確認滿意度
      this.checkIsSatisfactionSurveyFinish()
    },
    getTitleInfo () {  // 取得專區資訊
      this.infoLoading = true
      getCategoryDetail(this.$store.state.userInfo.id, this.$store.state.listAreaSerNo).then(result => {
        this.infoLoading = false
        if(result.header && result.header.status == '200'){
          this.categoryInfo = result.body[0]
        }
      })
    },
      columnSorting (fieldName) {
        console.log(`>>>>> columnSorting:${fieldName} <<<<<`)
        //切換表頭圖案
        if(this.order.fieldName == fieldName) {
            this.order.asc = !this.order.asc
        } else {
          console.log('change sort field')
          this.order.fieldName = fieldName
          this.order.asc = true
          console.log(this.order)
        }

        //data排序
        let sortOrder = -1
        if(this.order.asc) {
          sortOrder = 1
        }

        switch (fieldName) {
          case 'cenxpdt':
          case 'last_visitday':
          case 'printday':
          this.tableDataBackup = []  
            setTimeout(() => {
            this.tableDataBackup = [...this.tableData]
            this.tableDataBackup.sort(this.dateCompareFun(sortOrder, fieldName))
            this.allIdData = this.tableDataBackup.map(ele => {return ele.ceapcno})
            this.distinctid = this.allIdData.filter(function(element, index, arr){
              return arr.indexOf(element) === index;
            });
            this.registerHanlink() // 難字顯示
            if(this.checkAll){
              this.selection = []
              this.distinctid.forEach(data => {
              this.selection.push(data)
              });
              this.$emit('update', this.selection)
            }
            }, 20)
            break;
          case 'ceapcnm':
            getChangeNotice(this.$store.state.userInfo.id, sortOrder).then(result => {  // 取得客戶列表
              this.subsLoading = false;
              if(result && result.header.status == '200' && result.body){
                let lists = result.body.notice_list || [];
                let connect = '';
                let CsidData = '';
                lists.map(item => {
                    connect = connect+','+item.ceapcno;
                })
                if(connect.length > 0){
                  CsidData = connect.substr(1);
                } else {
                  CsidData = '';
                }
                queryBookedVisitEvent(this.$store.state.userInfo.id,CsidData).then(visitData => {
                  this.subsLoading = false;
                  if(visitData.header && visitData.header.status === '200') {
                    this.visitList = visitData.body.detail;
                    this.tableData = lists.map(item => {
                      let visit = {visit: {}};
                      this.visitList.forEach(vItem => {
                        if(vItem.csidno == item.ceapcno) {
                          visit.visit = vItem;
                        }
                      })
                      return {
                        ceapcnm: item.ceapcnm || '', //姓名(要保人資料）
                        name: item.ceapcnm || '', //客戶姓名
                        id:item.ceapcno || '', //客戶id
                        ceapcno: item.ceapcno || '', //客戶ID
                        celpscs_nm: item.celpscs_nm || '', //契約效力
                        ceplcno: item.ceplcno || '', //保單號碼
                        clcid : item.clcid || '',
                        contact : item.contact || '', //失聯狀況
                        fin : item.fin ||'',
                        idmark : item.idmark || '', //客戶標記
                        last_visitday: item.last_visitday || '',//實質接觸期限
                        cenxpdt: item.cenxpdt || '', //下次應繳日
                        visit_no: item.visit_no || '',//拜訪編號，存失聯件用
                        is_exist: item.is_exist || false, //判斷是否有客戶資料
                        printday: item.print_day || '', //列印日期
                        ...visit // 寫入排訪資料
                      }
                    })
                    this.allIdData = this.tableData.map(ele => {return ele.ceapcno;});
                    this.distinctid = this.allIdData.filter(function(element, index, arr){
                        return arr.indexOf(element) === index;
                    });
                    this.tableDataBackup = this.tableData.map(ele => {return ele;});
                  }
                })
                this.registerHanlink();  // for hard word
              }
            })
          break;
          default:
          this.tableDataBackup = []  
            setTimeout(() => {
            this.tableDataBackup = [...this.tableData]
            this.tableDataBackup.sort(this.sortCompareFun(sortOrder, fieldName))
            this.allIdData = this.tableDataBackup.map(ele => {return ele.ceapcno})
            this.distinctid = this.allIdData.filter(function(element, index, arr){
              return arr.indexOf(element) === index;
            });
            this.registerHanlink() // 難字顯示
            if(this.checkAll){
              this.selection = []
              this.distinctid.forEach(data => {
              this.selection.push(data)
              });
              this.$emit('update', this.selection)
            }
            }, 20)
            
        }
      },   
      dateCompareFun(sortOrder, property) {
        let vm = this
        return function(a, b) {
          let date_a = new Date(a[property]? a[property] : '1880-01-01').getTime() 
          let date_b = new Date(b[property]? b[property] : '1880-01-01').getTime() 
          let result = (date_a < date_b) ? -1 : 1
          return result * sortOrder
        }
      },
      sortCompareFun(sortOrder, property) {
        return function(a, b) {
          let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
          return result * sortOrder;
        }
      },       
    report() {
        this.$toast.info({title:'滿意度調查 已回報'});
        this.isBtnEnble = false
        this.panelClose('satisfactionModalOpen')
    },
    alreadyDone() {
      this.$toast.info({title: '您已回報過滿意度調查,無法重複操作'})
    },
    checkIsSatisfactionSurveyFinish () {
      // 檢查是否已回報過滿意度調查
      this.isLoading_btn = true
      isSatisfactionSurveyFinish(this.$store.state.userInfo.id, this.$store.state.listAreaSerNo).then(result => {
        if(result.header && result.header.status == '200') {
          this.isBtnEnble = result.body.isfinish == '0' 
        } else {
          if(result.header && result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '查詢滿意度調查失敗,請重新操作'})
          }
        }
        this.isLoading_btn = false
      })
    },
    submitGroup (group) {  // 加入群組導頁至 群組列表
      this.panelClose('groupModalOpen')
      this.$router.push({path:`/group/1`, query:{grp_id: group.grp_id, grp_name: group.grp_name}})
    },
    formatMark (str) {  // filter 客戶標記
      let idmark = [];

      if(str.includes('G')){
        idmark.push('黃金VIP')
      }
      if(str.includes('P')) {
        idmark.push('白金VIP')
      }
      if(str.includes('D')) {
        idmark.push('鑽石VIP')
      }
      if(str.includes('S')) {
        idmark.push('密戶')
      }

      return idmark.join(',')
    },
    updateSelection(val) {
      this.selection = val;
    },
    backToIndex() {  // 回上一頁
      this.$emit('change-status', 'STATUS_SERVICE_RIGHT_LIST');
    },
    openSendModal(custData, type) {  //打開 專函
      this.sendCustData = custData
      this.sendType = type
      this.panelOpen("sendModalOpen")
    },
    openAddressModal(custId, custName) {  //  打開保戶通聯
      this.subsLoading = true
      queryBelowEstrangePolicyContactInfo(this.$store.state.userInfo.id, custId, custName).then(result => {
        this.subsLoading = false
        if(result && result.header.status == '200' && result.body) {
          if (result.body.detail) {
            let iaaData = result.body.detail || {};
            //整理顯示內容
            iaaData.mobile = iaaData.mobl_no || ""; //手機號碼
            iaaData.homeTel = (iaaData.htel_area ? iaaData.htel_area + "-" : "") + (iaaData.htel_num ? iaaData.htel_num : "") + (iaaData.htel_ext ? "#" + iaaData.htel_ext : ""); //住家電話號碼
            iaaData.corpTel = (iaaData.ctel_area ? iaaData.ctel_area + "-" : "") + (iaaData.ctel_num ? iaaData.ctel_num : "") + (iaaData.ctel_ext ? "#" + iaaData.ctel_ext : ""); //公司電話號碼
            this.addressData = iaaData; //(客戶通聯資料)
            this.isRemoteDocumentWarningShow  = true;
          }
        }
        this.panelOpen("IntegratedAddressModalOpen");
      })
    },
    openMissingModal(visitNo, custId) {   // 是否失聯
      this.missCustId = custId
      this.subsLoading = true
      getChangeReprot(this.$store.state.userInfo.id, visitNo).then(result => {
        this.subsLoading = false
        if(result && result.header.status == '200' && result.body) {
          if (result.body.notice_contact) {
            this.missingContact = result.body.notice_contact.contact
          } else {
            this.missingContact = ''
          }
          this.panelOpen("MissingModalOpen");
        }
      })
    },
    updateMissing (val) {  // 更新失聯
     getChangeUpdateReprot(this.$store.state.userInfo.id, this.missCustId, val).then(result => {
        if(result && result.header.status == '200' && result.body) {
          this.setToastMsg(result.header.message)
        }else{
          this.setToastMsg(result.header.message)
        }
        this.panelClose("MissingModalOpen")
        this.initCustList() 
      })
    },
    toCustDetail({custId = '', custName = '', serNo = ''}) {  // 導頁至客戶資料
      if (custId !== "") {
        if (this.isBox) {
          //若内嵌於Box, 將客戶資訊回傳給Box
          this.boxCustInfo(custId, custName);
        } else {
          this.updateCustID(custId);
          this.updateSerNo('');
          localStorage.CustID = custId;
          localStorage.SerNo = '';
          this.$router.push({ path: `/detail/CustID/tab/1` });
        }
      } else {
        this.updateSerNo(serNo);
        this.updateCustID('');
        localStorage.CustID = '';
        localStorage.SerNo = serNo;
        this.$router.push({ path: `/detail/SerNo/tab/1` });
      }
    },
    satisfactionModal() {
        this.panelOpen('satisfactionModalOpen');
    },
    backToIndex() {  // 回上一頁
      this.$emit('change-status', 'STATUS_SERVICE_RIGHT_LIST');
    },
    download () {
      if (this.$store.state.userInfo.userType === "box") {
        //若内嵌於Box, 將檔案資訊回傳給Box
        this.boxDownload(
          this.categoryInfo.upload_file,
          this.categoryInfo.ser_no
        );
      } else {
        let vm = this;
        downloadFile_m0(this.$store.state.userInfo.id, this.categoryInfo.ser_no, this.categoryInfo.upload_file).then(
          result => {
            if (result.type == "application/json") {
              //  json 為檔案下載失敗
              //  把回傳的 blob 轉為 文字檔後再用 json parse
              let reader = new FileReader();
              reader.onload = function() {
                let unicodeJsonA = JSON.parse(reader.result);
                if (unicodeJsonA.header.message) {
                  vm.setToastMsg(unicodeJsonA.header.message);
                } else {
                  vm.setToastMsg("伺服器連線異常");
                }
              };
              reader.readAsText(result);
            } else {
              //  成功取得檔案  進行下載
              saveAs(result, this.categoryInfo.upload_file);
            }
          }
        );
      }
    },
    ScheduledAccess(record) { //排訪功能
      this.currentRecord = record;
      this.panelOpen('ScheduledAccessModalOpen');
    },
    submitScheduledAccess() { //排訪功能-儲存
      this.panelClose('ScheduledAccessModalOpen');
      // 資料初始化
      this.initCustList();
    },
    openPrintAllModal() {  //  打開列印專函
      if (this.selection.length > 100) {
          return this.setToastMsg(
            `單次勾選要保人數超過上限(100位)`
          );
        }
      this.panelOpen("printallModalOpen");
    },
    Closeprintall(){
      this.panelClose('printallModalOpen');
    },
    ClosesendModal(){
      this.panelClose('sendModalOpen');
    },
    callBoxVisit(data) {
      //連至Box排訪
      this.boxVisit(data, this.categoryInfo);
    }
  },
  mounted() {
    // 初始化頁面
    this.initCustList()

    // 監聽視窗寬度
    const self = this

    window.onresize = () => {
      return (() => {
        if(document.body.clientWidth > 1220) {
          window.screenWidth = 1220;
          self.screenWidth = 1220
        } else {
          window.screenWidth = document.body.clientWidth;
          self.screenWidth = window.screenWidth;
        }
      })();
    };

    this.scrollHeight =  parseInt($(window).height()) - $('tbody').offset().top - 85 ;
    $(window).bind('resize', function(event) {
      self.scrollHeight = parseInt($(window).height()) - $('tbody').offset().top - 85 ;
    });
    $(".tab-content").css("padding-bottom","62px");    

  },
  
};
</script>

<style lang="scss" scoped>

.newTable thead tr,.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.newTable tbody {
  display: block;
  // height: 552px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;
  
  &::-webkit-scrollbar {
    width: 17px; 
    border: 0;
    box-shadow: none;
  }
  
  &::-webkit-scrollbar-track
  {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb
  {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}

</style>